<template>
    <div class="indexStyle">
        <home-heard></home-heard>
        
        <router-view class="router-view"/>

        <!-- <home-foot></home-foot> -->
    </div>
</template>


<script scope>
import HomeHeard from "@/components/HomeHeard"
import HomeFoot from "@/components/HomeFoot"
export default {
    name: "home",
    components:{
        HomeHeard,
        HomeFoot
    },
    data() {
        return {
        msg: ""
        };
    },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.router-view{
    /* height:calc(100% - 71px);
    margin-top: 71px; */
    height: 100%;
}
/* 产品与方案 */

</style>



// WEBPACK FOOTER //
// src/views/index.vue